import { render, staticRenderFns } from "./UsuarioDados.vue?vue&type=template&id=a6baff6c"
import script from "./UsuarioDados.vue?vue&type=script&lang=js"
export * from "./UsuarioDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports